import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FnBreadcrumbComponent } from './fn-breadcrumb.component';
import { FnTranslateModule } from '../../i18n/index';
export * from './fn-breadcrumb.component';

/** 
 * Exports the required FnBreadcrumbComponent to create navigation bar on top of webPage after MenuBar
 * making them available for import by NgModules that import this module.
 */

@NgModule({
	declarations: [FnBreadcrumbComponent],
	imports: [CommonModule,  FnTranslateModule],
	exports: [FnBreadcrumbComponent],
})
export class FnBreadcrumbModule {}
